export const environment = {
  production: false,
  apiUrl:'https://apichn.narola.in',
  googleCaptchaKey:'6LfuJLwZAAAAAGryCIEVsnFHn7-mNg40o-3k7USh',
  tinyApikey:'ohukokmifhmxbb45h89ybs6gvbabl0uy5sc2sy4ewp2vqgf3',
  NotificationApiUrl:'https://push.narola.in',
  wsapiUrl:'https://ws.narola.in'
};
